export const TERMINAL = {
  IDLE: "idle",
  BOOT: "boot",
  ANALYZING: "analyzing",
  ASKING: "asking",
  TYPING: "typing",
  ERROR: "error"
};